export default __webpack_public_path__ + "static/intern_w-7c1b7eef28ddb913783eb60bb5ece1f3.webp";